import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import {
  authSerialSlice,
  AuthSerialState,
} from '@/states/slices/authSerialSlice';
import { AppDispatch, RootState, useAppDispatch } from '@/states/store';

/**
 * 認証用シリアルに関する情報を保存 hooks
 *
 * @returns
 */
export const useAuthSerial = () => {
  const dispatch: AppDispatch = useAppDispatch();

  const { setSerial, clearSerial } = authSerialSlice.actions;

  const { serial } = useSelector<RootState, AuthSerialState>(
    (state) => state.authSerial,
  );

  /**
   * シリアルを更新
   */
  const changeSerial = useCallback(
    (value: string) => {
      dispatch(setSerial(value));
    },
    [dispatch, setSerial],
  );

  /**
   * 全てのStateをリセット
   */
  const resetState = useCallback(() => {
    dispatch(clearSerial());
  }, [clearSerial, dispatch]);

  return {
    serial,
    setSerial: changeSerial,
    resetState,
  };
};
